import { useSelector } from "react-redux";

import { isLocationProjectConfigurationSelector } from "../../ducks/location/selectors";

export const useIsConfiguration = (): boolean => {
  return useSelector(isLocationProjectConfigurationSelector);
};
